/**
 *   V1.0
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * 维护中...
 *
 **/
const ExcelJS = require('exceljs');

/***
 * 将二进制转为ExcelJS并下载
 */
function writeFile (fileName, content){
    let a = document.createElement("a");
    let blob = new Blob([content], { type: "text/plain" });
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.click();
}
/**
 * 根据缩略图URL获得原图URL
 * @param thumbUrl 缩略图地址
 *
 * 例如将 http://static-foo.essatoy.com/cd54e12b-583f-45b0-9daf-c603a7182d5d.jpg?x-oss-process=image/resize,m_pad,w_1980,h_340 变为
 * http://static-foo.essatoy.com/cd54e12b-583f-45b0-9daf-c603a7182d5d.jpg
 *
 * 将http://static-foo.essatoy.com/cd54e12b-583f-45b0-9daf-c603a7182d5d.jpg@!300 变为
 * http://static-foo.essatoy.com/cd54e12b-583f-45b0-9daf-c603a7182d5d.jpg
 */
function getOriginImageUrlByThumbUrl(thumbUrl) {
    if (thumbUrl) {
        let index = thumbUrl.lastIndexOf("@!");
        if (index > 0) {
            const url = thumbUrl.substring(0, index);
            return url;
        }
        index = thumbUrl.lastIndexOf("?x-oss-process");
        if (index > 0) {
            const url = thumbUrl.substring(0, index);
            return url;
        }
        return thumbUrl;
    }
    return null;
}
function getBase64Image(img, width, height) {
    let canvas = document.createElement("canvas");
    canvas.width = width ? width : img.width;
    canvas.height = height ? height : img.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL();
}
function getCanvasBase64(img) {
    let image = new Image();
    image.crossOrigin = '';
    image.src = img+ '?v=' + Math.random();
    const deferred = $.Deferred();
    if (img) {
        image.onload = function () {
            deferred.resolve(getBase64Image(image));
        }
        return deferred.promise();
    }
}
const utilExcelStrict ={
    /**
     * 读取缓冲文件
     * @file 文件数据
     * @callback 回调第一个sheet的数据
     * */
    readFileByBuffer : function(file,callback){
        const fileReader = new FileReader();
        fileReader.readAsBinaryString(file);
        fileReader.onload = event => {
            let resList = []
            try {
                const {result} = event.target;
                const workbook = new ExcelJS.Workbook();
                workbook.xlsx.load(result).then(function () {
                    const worksheet = workbook.getWorksheet(1); //获取第一个worksheet
                    worksheet.eachRow(function (row, rowNumber) {
                        // console.log('行 ' + rowNumber + ' = ' + JSON.stringify(row.values));
                        resList.push(row.values)
                    });
                    return callback(resList);
                }).catch(err=>{
                    return callback(resList);
                });

            } catch (e) {
                // 这里可以抛出文件类型错误不正确的相关提示
                console.error('文件类型不正确！');
                return callback(resList);
            }
        };
    },

    /**
     * 导出文件 todo 待优化灵活处理图片
     * @columns 栏目
     * @dataSource 数据源
     * @title 标题
     * @callback 回调
     * */
    exportFile : async function (columns,dataSource,title,callback){
        try{
            // 初始化 创建工作簿
            const workbook = new ExcelJS.Workbook();
            // 设置工作簿属性
            workbook.creator = "admin";
            workbook.lastModifiedBy = "admin";
            workbook.created = new Date();
            workbook.modified = new Date();
            // 添加工作表
            let sheet = workbook.addWorksheet("sheet");
            // 添加表头
            sheet.columns = columns;
            if (Array.isArray(dataSource)) {
                let inx = 1;
                for (let item of dataSource) {
                    const sImage = getOriginImageUrlByThumbUrl(item.thumbnail);
                    if (sImage) {
                        const base64 = await getCanvasBase64(sImage);
                        const imageId2 = workbook.addImage({
                            base64: base64,
                            extension: 'png',
                        });
                        sheet.addImage(imageId2, {
                            tl: {col: 0, row: inx}, //从第0行开始 写入
                            ext: {width: 150, height: 150}
                        });
                    }
                    sheet.addRow(item);
                    const tr = sheet.getRow(inx+1);//从第一行开始 get
                    tr.height = 130;
                    // ===== 字体显示
                    tr.font = {
                        name: 'Noto Sans SC',
                    };
                    inx += 1;
                }
                const tr = sheet.getRow(1);
                tr.eachCell((cell, rowNumber) => {
                    sheet.getColumn(rowNumber).alignment = {
                        vertical: "middle",
                        horizontal: "center",
                        wrapText: true,
                    };
                });
                workbook.xlsx.writeBuffer().then((buffer) => {
                    writeFile(`${title}.xlsx`, buffer);
                });
            }
            return callback('')
        }catch(err){
            // console.log('错误',err)
            return callback(err)
        }
    }
}

export default utilExcelStrict;
